let rezMax = 0;
let windowWidth = window.innerWidth;
if (windowWidth >= 1780) {
  rezMax = 4
} else if (windowWidth > 1280) {
  rezMax = 3;
} else if (windowWidth > 1000) {
  rezMax = 2
} else {
  rezMax = 1
}

export default rezMax ;
